// GENERATED by scripts/generate-mega-moves.ts — do not edit.
// Source: PokeMiners Game Master VM_MOVE_TEMP_EVOLUTION_MEGA* (PvE) +
// COMBAT_VM_MOVE_TEMP_EVOLUTION_MEGA* (PvP) templates, and the
// MEGA_EVOLUTION_LEVEL_4_* templates for which species reach Super Max.
// 13 moves, 11 Super Max species.

export interface MegaMove {
  dexId: number;
  /** "" / "X" / "Y", matching the Mega stats table. */
  form: string;
  name: string;
  /** Lowercase type key. */
  type: string;
  pvePower: number;
  pveDurationMs: number;
  /** Energy the charged move spends in raids and gyms. */
  pveEnergy: number;
  pvpPower: number;
  pvpEnergy: number;
  /** Stat-stage effect in PvP ("100%: -2 Def (foe)"), or null. */
  pvpBuff: string | null;
}

/** The additional Charged Attack a Mega has while Mega Evolved at Super Max. */
export const MEGA_MOVES: readonly MegaMove[] = [
  { dexId: 26, form: "X", name: "Volt Tackle", type: "electric", pvePower: 170, pveDurationMs: 3500, pveEnergy: 100, pvpPower: 65, pvpEnergy: 35, pvpBuff: "100%: -1 Def (self)" },
  { dexId: 26, form: "Y", name: "Zap Cannon", type: "electric", pvePower: 160, pveDurationMs: 3500, pveEnergy: 100, pvpPower: 70, pvpEnergy: 45, pvpBuff: "100%: -1 Atk (foe)" },
  { dexId: 71, form: "", name: "Acid Spray", type: "poison", pvePower: 160, pveDurationMs: 3000, pveEnergy: 100, pvpPower: 20, pvpEnergy: 40, pvpBuff: "100%: -2 Def (foe)" },
  { dexId: 121, form: "", name: "Liquidation", type: "water", pvePower: 180, pveDurationMs: 3000, pveEnergy: 100, pvpPower: 55, pvpEnergy: 40, pvpBuff: "30%: -1 Def (foe)" },
  { dexId: 149, form: "", name: "Outrage", type: "dragon", pvePower: 185, pveDurationMs: 4000, pveEnergy: 100, pvpPower: 80, pvpEnergy: 50, pvpBuff: null },
  { dexId: 150, form: "X", name: "Dynamic Punch", type: "fighting", pvePower: 130, pveDurationMs: 2500, pveEnergy: 100, pvpPower: 130, pvpEnergy: 80, pvpBuff: null },
  { dexId: 150, form: "Y", name: "Future Sight", type: "psychic", pvePower: 140, pveDurationMs: 2500, pveEnergy: 100, pvpPower: 130, pvpEnergy: 80, pvpBuff: null },
  { dexId: 227, form: "", name: "Drill Peck", type: "flying", pvePower: 170, pveDurationMs: 2500, pveEnergy: 100, pvpPower: 60, pvpEnergy: 35, pvpBuff: null },
  { dexId: 652, form: "", name: "Seed Bomb", type: "grass", pvePower: 150, pveDurationMs: 2000, pveEnergy: 100, pvpPower: 60, pvpEnergy: 40, pvpBuff: null },
  { dexId: 655, form: "", name: "Mystical Fire", type: "fire", pvePower: 140, pveDurationMs: 2000, pveEnergy: 100, pvpPower: 50, pvpEnergy: 40, pvpBuff: "100%: -1 Atk (foe)" },
  { dexId: 658, form: "", name: "Surf", type: "water", pvePower: 130, pveDurationMs: 1500, pveEnergy: 100, pvpPower: 55, pvpEnergy: 35, pvpBuff: null },
  { dexId: 687, form: "", name: "Psybeam", type: "psychic", pvePower: 170, pveDurationMs: 3000, pveEnergy: 100, pvpPower: 60, pvpEnergy: 45, pvpBuff: null },
  { dexId: 870, form: "", name: "Brick Break", type: "fighting", pvePower: 150, pveDurationMs: 1500, pveEnergy: 100, pvpPower: 40, pvpEnergy: 35, pvpBuff: "100%: -1 Def (foe)" },
];

/** Species with a Super Max level in the Game Master, and the Mega Energy to unlock it. */
export const SUPER_MAX_UNLOCK: Readonly<Record<number, number>> = {
  26: 5000,
  71: 5000,
  121: 5000,
  149: 5000,
  150: 5000,
  227: 5000,
  652: 5000,
  655: 5000,
  658: 5000,
  687: 5000,
  870: 5000,
};

/** The Super Max move for a base species and Mega form label ("" / "X" / "Y"). */
export function megaMoveFor(dexId: number, form = ""): MegaMove | null {
  return MEGA_MOVES.find((m) => m.dexId === dexId && m.form === form) ?? null;
}
